/**
 * Created by Pradeep Kumar on 06/04/2019.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TweenLite} from "gsap";
import {TombOfNefertitiGameMode} from "../gamemode/TombOfNefertitiGameMode";
import {TombOfNefertitiGameShaker} from "../gameshake/TombOfNefertitiGameShaker";
import {ITombOfNefertitiGameData, ITombOfNefertitiInitData} from "../server/data/ITombOfNefertitiServerData";
import {TombOfNefertitiGameAssets} from "../TombOfNefertitiGameAssets";
import {TombOfNefertitiGameConfig} from "../TombOfNefertitiGameConfig";
import {TombOfNefertitiSoundConfig} from "../TombOfNefertitiSoundConfig";

export class TombOfNefertitiMultiplierEvents {
    static readonly TRY_MULTIPLIER_UPDATE:string = "TombOfNefertitiMultiplierEvents_tryMultiplierUpdate";
    static readonly MULTIPLIER_UPDATED:string = "TombOfNefertitiMultiplierEvents_multiplierUpdated";
    static readonly MULTIPLIER_SHOWN:string = "TombOfNefertitiMultiplierEvents_multiplierShown";
}

export class TombOfNefertitiMultiplier extends BaseView {

    private _multiplier:BitmapCountUp;
    private _fsMultiplier:BitmapCountUp;
    private _prevMultiplier:number = 1;
    private _nextMultiplier:number = 1;
    private _respinPlayed:number = 0;
    private _isRespinTriggered:boolean;

    private _currentGameMode:string;
    private _nextGameMode:string;

    private _bg:PIXI.Sprite;
    private _portraitBg:PIXI.Sprite;
    private _bgState:string = '';

    private _frameName:string = '';
    private _indicatorIndex:number;

    private _scaleFrom:number;
    private _scaleTo:number;

    private _normalMultiplierAnimation:TimelineSprite;
    private _winMultiplierAnimation:TimelineSprite;

    private _orientation:string;

    public updateIndicatorState(initializing:boolean, value:number, nextMode?:string):void {
        let indicatorIndex:number = 1;

        if((nextMode || this._nextGameMode).indexOf('RESPIN') !== -1) {
            indicatorIndex = (value + 1 + 1);
        }

        if(initializing) {
            indicatorIndex -= 1;
        } else {
            this._normalMultiplierAnimation.visible = true;
            this._normalMultiplierAnimation.playLoop();
        }

        this._indicatorIndex = indicatorIndex;

        this.setTexture();
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this,"updateMultiForAS",(event:GameEvent)=>{
            const data=event.params[0];
            this._nextMultiplier = data.payoutWinMultiplier;
            this._respinPlayed = data.respinPlayed;
            this._currentGameMode = data.mode;
            this._nextGameMode = data.nextMode;
        })
        EventHandler.addEventListener(this, TombOfNefertitiMultiplierEvents.TRY_MULTIPLIER_UPDATE, (event:GameEvent) => this.tryUpdateMultiplier(event.params[0]));
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event:GameEvent) => this.updateIndicatorForNextSpin(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.IDLE, () => this.onIdle());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => {
            const val:number = this._nextMultiplier,
                reSpins:number = this._respinPlayed,
                nextMode:string = this._nextGameMode;

            TweenLite.delayedCall(TombOfNefertitiGameConfig.instance.SPIN_DELAY, () => this.updateMultiplier(val));
            TweenLite.delayedCall(TombOfNefertitiGameConfig.instance.SPIN_DELAY, () => this.updateIndicatorState(false, reSpins, nextMode));
        });
    }

    protected initAnimations():void {
        this._normalMultiplierAnimation = new TimelineSprite(GameResources.getTextures("multiplierNormal"));
        this._winMultiplierAnimation = new TimelineSprite(GameResources.getTextures("multiplierWin"));

        this._normalMultiplierAnimation.blendMode = PIXI.BLEND_MODES.COLOR_BURN;
        this._winMultiplierAnimation.blendMode = PIXI.BLEND_MODES.COLOR_BURN;

        this._normalMultiplierAnimation.anchor.set(0.5);
        this._winMultiplierAnimation.anchor.set(0.5);

        this.addChild(this._normalMultiplierAnimation);
        this.addChild(this._winMultiplierAnimation);

        this._normalMultiplierAnimation.visible = false;
        this._winMultiplierAnimation.visible = false;

        this._bg = new PIXI.Sprite(GameResources.getTextures(TombOfNefertitiGameAssets.MULTIPLIER)[0]);
        this._portraitBg = new PIXI.Sprite(GameResources.getTextures(TombOfNefertitiGameAssets.MULTIPLIER)[0]);

        this._bg.anchor.set(0.5);
        this._bg.position.set(950, 40);

        this._portraitBg.anchor.set(0.5);
        this._portraitBg.position.set(960, -10);
        this._portraitBg.scale.set(2.15);

        this._multiplier = new BitmapCountUp({
            style : {
                font : {
                    name : "multiplierFont",
                    size : 32
                },
                tint : parseInt(("#FFFFFF").replace(/^#/, ''), 16)
            }
        });
        this._multiplier.maxTextWidth = TombOfNefertitiGameConfig.instance.GAME_WIDTH;
        this._multiplier.text = "x" + this._nextMultiplier;

        this.addChild(this._bg);
        this.addChild(this._portraitBg);
        this.addChild(this._multiplier);

        // fix for #195
        this._multiplier.pivot.set((this._multiplier.width / this._multiplier.text.length), this._multiplier.height / 2);

        const layer = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
        layer.addChild(this);

        this.createFSMultiplier();

        if(this._nextGameMode) {
            this.updateIndicatorState(true, this._respinPlayed);
        }
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._bg.visible = false;

            this._portraitBg.visible = true;

            this._scaleFrom = 2.0;
            this._scaleTo = 5.0;

            this._multiplier.scale.set(2);
            this._multiplier.x = this._portraitBg.x - (this._scaleFrom * (((this._multiplier.width / this._multiplier.text.length)) / 2) * (this._multiplier.text.length - 2));
            this._multiplier.y = 7;

            this._normalMultiplierAnimation.position.set(960, -10);
            this._winMultiplierAnimation.position.set(960, -10);
            this._normalMultiplierAnimation.scale.set(1.4);
            this._winMultiplierAnimation.scale.set(1.4);
        } else {
            this._bg.visible = true;

            this._portraitBg.visible = false;

            this._scaleFrom = 1;
            this._scaleTo = 2.5;

            this._multiplier.scale.set(1);
            this._multiplier.x = this._bg.x - (this._scaleFrom * (((this._multiplier.width / this._multiplier.text.length)) / 2) * (this._multiplier.text.length - 2));
            this._multiplier.y = 47;

            this._normalMultiplierAnimation.position.set(950, 40);
            this._winMultiplierAnimation.position.set(950, 40);
            this._normalMultiplierAnimation.scale.set(1);
            this._winMultiplierAnimation.scale.set(1);
        }

        this._frameName = TombOfNefertitiGameAssets.MULTIPLIER_DYNAMIC;
        this._orientation = resizeData.orientation;

        this.setTexture();
    }

    private onIdle():void {
        this._indicatorIndex = 0;

        this._normalMultiplierAnimation.stopLoop();
        this._normalMultiplierAnimation.visible = false;

        this.setTexture();
    }

    private setTexture():void {
        let frameName:string = TombOfNefertitiGameAssets.MULTIPLIER,
            scale:number,
            tint:number;

        tint = (this._bgState === "FS") ? 0xfc464c : 0x2ea2f4;

        scale = (this._orientation === Orientation.PORTRAIT) ? 2.2 : 1;

        const indicatorIndex:number = this._indicatorIndex;

        if(indicatorIndex) {
            frameName = this._frameName + indicatorIndex;
        }

        let frameNameArr:string[] = frameName.split('/');
        frameNameArr[frameNameArr.length - 1] = this._bgState + frameNameArr[frameNameArr.length - 1];
        frameName = frameNameArr.join('/');

        this._bg.texture = GameResources.getTextures(frameName)[0];
        this._portraitBg.texture = GameResources.getTextures(frameName)[0];

        this._normalMultiplierAnimation.scale.set(scale);
        (this._normalMultiplierAnimation as any).tint = tint;
        this._winMultiplierAnimation.scale.set(scale);
        (this._winMultiplierAnimation as any).tint = tint;
    }

    private updateIndicatorForNextSpin(nextGameMode:IGameModeChangedData):void {
        this._bgState = '';
        if(nextGameMode.newMode.indexOf(GameMode.FREESPIN) !== -1) {
            this._bgState = 'FS';
        }
        this._indicatorIndex = 0;

        this.setTexture();

        this.updateMultiplier(this._nextMultiplier, true);
    }

    private createFSMultiplier():void {
        this._fsMultiplier = new BitmapCountUp({
            style : {
                font : {
                    name : "multiplierFont",
                    size : 100
                },
                tint : parseInt(("#FFFFFF").replace(/^#/, ''), 16)
            }
        });
        this._fsMultiplier.maxTextWidth = TombOfNefertitiGameConfig.instance.GAME_WIDTH;
        this._fsMultiplier.visible = false;

        StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.MULTIPLIER.name).addChild(this._fsMultiplier);
    }

    private onInitDataParsed(data:ITombOfNefertitiInitData) {
        this._nextMultiplier = data.payoutWinMultiplier;
        this._currentGameMode = data.mode;
        this._nextGameMode = data.nextMode;
        this._respinPlayed = data.respinPlayed;

        // #269
        if((this._currentGameMode === GameMode.NORMAL || this._currentGameMode === TombOfNefertitiGameMode.RESPIN) && this._nextGameMode === GameMode.FREESPIN) {
            this._nextMultiplier = 1;
        }

        if(this._bg) {
            this.updateIndicatorState(true, this._respinPlayed);
        }
    }

    private onGameDataParsed(data:ITombOfNefertitiGameData) {
        this._nextMultiplier = data.payoutMultiplierNext;
        this._respinPlayed = data.respinPlayed;
        this._isRespinTriggered = data.isRespinTriggered;
        this._currentGameMode = data.mode;
        this._nextGameMode = data.nextMode;
    }

    private tryUpdateMultiplier(isAborted:boolean):void {
        if(this._nextMultiplier !== this._prevMultiplier && this._nextGameMode !== GameMode.NORMAL) {
            if(!isAborted && this._nextGameMode !== GameMode.NORMAL) {
                this.updateFSMultiplier();
            } else {
                this.updateMultiplier(this._nextMultiplier);
            }
        }
    }

    private updateMultiplier(value:number, modeChangedOrSpinStarted?:boolean):void {
        let indicatorValue:number = Number(this._multiplier.text.split('x')[1]);
        if(value === indicatorValue) {
            return;
        }

        this._prevMultiplier = this._nextMultiplier;

        if(!modeChangedOrSpinStarted) {
            if(this._currentGameMode.indexOf(GameMode.FREESPIN) === -1) {
                SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.MULTIPLIER_UPDATE);
            } else {
                SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.FS_MULTIPLIER_UPDATE);
            }
        }

        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiMultiplierEvents.MULTIPLIER_UPDATED, this._nextMultiplier));

        if(this._nextMultiplier !== 1) {
            this._normalMultiplierAnimation.visible = false;

            this._winMultiplierAnimation.visible = true;
            this._winMultiplierAnimation.alpha = 1;
            this._winMultiplierAnimation.getAnimation(undefined, undefined, () => {
                TweenLite.to(this._winMultiplierAnimation, 0.2, {
                    alpha : 0, onComplete : () => {
                        this._normalMultiplierAnimation.visible = true;
                    }
                });
            });
        }

        TweenLite.to(this._multiplier.scale, 0.1, {
            x : this._scaleTo, y : this._scaleTo, onComplete : () => {
                this._multiplier.text = "x" + value;

                if(this._orientation === Orientation.PORTRAIT) {
                    this._multiplier.x = this._portraitBg.x - (this._scaleFrom * (((this._multiplier.width / this._multiplier.text.length)) / 2) * (this._multiplier.text.length - 2));
                } else {
                    this._multiplier.x = this._bg.x - (this._scaleFrom * (((this._multiplier.width / this._multiplier.text.length)) / 2) * (this._multiplier.text.length - 2));
                }

                TweenLite.to(this._multiplier.scale, 0.1, {x : this._scaleFrom, y : this._scaleFrom});
            }
        });
    }

    private updateFSMultiplier():void {
        const value:number = this._nextMultiplier,
            scaleTo:number = this._currentGameMode.indexOf(GameMode.FREESPIN) !== -1 ? 2 : 1,
            pos:number[] = Helper.getSymbolPositions(Math.floor(TombOfNefertitiGameConfig.instance.REELS_NUM / 2), 0);

        this._fsMultiplier.text = "x" + this._nextMultiplier;
        this._fsMultiplier.visible = true;
        this._fsMultiplier.scale.set(4);
        this._fsMultiplier.position.set(pos[0] - ((scaleTo === 1) ? this._fsMultiplier.width / 4 : this._fsMultiplier.width / 2), pos[1]);

        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiMultiplierEvents.MULTIPLIER_SHOWN));

        TweenLite.to(this._fsMultiplier.scale, 0.1, {
            x : scaleTo, y : scaleTo, onComplete : () => {
                SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.FS_NEW_MULTIPLIER_REVEAL);

                EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.START_GAME_SHAKING_REEL_AREA_FS_MODE));

                TweenLite.to(() => {}, 1, {
                    onComplete : () => {
                        TweenLite.to(this._fsMultiplier, 0.3, {
                            x : this._multiplier.x, y : this._multiplier.y
                        });
                        TweenLite.to(this._fsMultiplier.scale, 0.3, {
                            x : 0, y : 0, onComplete : () => {
                                this._fsMultiplier.visible = false;
                                this.updateMultiplier(value);
                            }
                        });
                        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.STOP_GAME_SHAKING));
                    }
                });
            }
        });
    }
}